import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  CssBaseline,
  ThemeProvider,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import theme from "../../../config/theme";
import Blog1 from "../../../assets/Blog1.png";
import Blog2 from "../../../assets/Blog2.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ReadButton = styled(Button)({
  height: "0.6875rem",
  width: "6.75rem",
  fontSize: "0.5rem",
  fontWeight: 700,
  letterSpacing: "0.0532384375rem",
  gap: "0.5rem",
  textAlign: "center",
});

export const BlogTypography = styled(Typography)({
  fontSize: "3.75rem",
  fontWeight: 700,
  letterSpacing: "0.03125rem",
  color: "#212121",
  textAlign: "center",
});

export const colData = [
  {
    rowData: [
      {
        image: Blog2,
        title: "Lorem ipsum fortis fortuna adiipsum dolor onsecteturs...",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore i...",
      },
      {
        image: Blog1,
        title: "Lorem ipsum fortis fortuna adiipsum dolor onsecteturs...",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore i...",
      },
      {
        image: Blog2,
        title: "Lorem ipsum fortis fortuna adiipsum dolor onsecteturs...",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore i...",
      },
    ],
  },
  {
    rowData: [
      {
        image: Blog2,
        title: "Lorem ipsum fortis fortuna adiipsum dolor onsecteturs...",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore i...",
      },
      {
        image: Blog1,
        title: "Lorem ipsum fortis fortuna adiipsum dolor onsecteturs...",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore i...",
      },
      {
        image: Blog2,
        title: "Lorem ipsum fortis fortuna adiipsum dolor onsecteturs...",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore i...",
      },
    ],
  },
  {
    rowData: [
      {
        image: Blog2,
        title: "Lorem ipsum fortis fortuna adiipsum dolor onsecteturs...",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore i...",
      },
      {
        image: Blog1,
        title: "Lorem ipsum fortis fortuna adiipsum dolor onsecteturs...",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore i...",
      },
      {
        image: Blog2,
        title: "Lorem ipsum fortis fortuna adiipsum dolor onsecteturs...",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore i...",
      },
    ],
  },
];

const colData2 = [
  {
    rowData2: [
      {
        image: Blog2,
        title: "Lorem ipsum dolor sit amet, consectetur due...",
        description:
          "Lorem ipsum dolor srem ipsum dolor sit amet, consectetur adipiscing...",
      },
      {
        image: Blog1,
        title: "Lorem ipsum dolor sit amet, consectetur due...",
        description:
          "Lorem ipsum dolor srem ipsum dolor sit amet, consectetur adipiscing...",
      },
    ],
  },
  {
    rowData2: [
      {
        image: Blog2,
        title: "Lorem ipsum dolor sit amet, consectetur due...",
        description:
          "Lorem ipsum dolor srem ipsum dolor sit amet, consectetur adipiscing...",
      },
      {
        image: Blog1,
        title: "Lorem ipsum dolor sit amet, consectetur due...",
        description:
          "Lorem ipsum dolor srem ipsum dolor sit amet, consectetur adipiscing...",
      },
    ],
  },
  {
    rowData2: [
      {
        image: Blog2,
        title: "Lorem ipsum dolor sit amet, consectetur due...",
        description:
          "Lorem ipsum dolor srem ipsum dolor sit amet, consectetur adipiscing...",
      },
      {
        image: Blog1,
        title: "Lorem ipsum dolor sit amet, consectetur due...",
        description:
          "Lorem ipsum dolor srem ipsum dolor sit amet, consectetur adipiscing...",
      },
    ],
  },
];

const Blogs = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isMobile ? (
        <Container>
          <Box sx={{ marginTop: "2.5rem" }}>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.375rem",
                fontWeight: 700,
                letterSpacing: "0.010681125rem",
                textAlign: "center",
              }}
            >
              Blogs
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1.25rem",
            }}
          >
            <img
              src={Blog1}
              alt=""
              style={{
                width: "21.875rem",
                maxHeight: "17.25rem",
                borderRadius: "0.75rem",
              }}
            />
          </Box>
          <Typography
            variant="h4"
            sx={{
              marginTop: "1.25rem",
              color: "#212121",
              fontSize: "1rem",
              fontWeight: 700,
              letterSpacing: "0.01199775rem",
              lineHeight: "1.9375rem",
            }}
          >
            Simplifying Complexity: Designing an Uncluttered EdTech Admin Interface
          </Typography>
          <Typography
            variant="h4"
            sx={{
              marginTop: "1.25rem",
              color: "#212121",
              fontSize: "0.75rem",
              fontWeight: 400,
              letterSpacing: "0.0079055rem",
              lineHeight: "1.25rem",
            }}
          >
            In the dynamic landscape of educational technology, efficiency is key. In this article, we delve into the art and science of designing an uncluttered administrative interface for your edtech platform. Join us as we explore strategies to declutter, streamline, and optimize the admin experience, ensuring that educators and administrators can focus on what truly matters: shaping the future of education. Discover how simplicity and efficiency converge to revolutionize the way you navigate the complexities of edtech administration.
          </Typography>
          <Box
            sx={{
              marginTop: "1.25rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ReadButton component={Link} to={"/blog"} style={{ whiteSpace: "nowrap" }}>
              READ FULL ARTICLE
              <KeyboardArrowDownIcon
                style={{
                  height: "1rem",
                  width: "1rem",
                }}
              />
            </ReadButton>
          </Box>
          <Box sx={{ marginTop: "2.5rem", marginBottom: "1.25rem" }}>
            {colData2.map((item, index) => (
              <Box
                sx={{
                  marginBottom: "1.25rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
                key={index}
              >
                {item.rowData2.map((item, index) => (
                  <Card
                    sx={{
                      height: "14.9375rem",
                      width: "10.375rem",
                      boxShadow: "0px 8px 24px rgba(88, 101, 242, 0.15)",
                      position: "relative",
                    }}
                    key={index}
                  >
                    <CardMedia
                      component="img"
                      alt=""
                      image={item.image}
                      sx={{
                        height: "8.125rem",
                        width: "100%",
                      }}
                    />
                    <Typography
                      variant="h4"
                      sx={{
                        transform: "translateY(-100%)",
                        flexWrap: "nowrap",
                        position: "absolute",
                        color: "#FFFFFF",
                        width: "9.375rem",
                        fontSize: "0.75rem",
                        letterSpacing: "0.0079055rem",
                        fontWeight: 700,
                        textAlign: "center",
                        lineHeight: "1.25rem",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <CardContent>
                      <Typography
                        variant="h4"
                        sx={{
                          lineHeight: "1.25rem",
                          width: "9.375rem",
                          fontSize: "0.75rem",
                          fontWeight: 400,
                          letterSpacing: "0.0079055rem",
                          color: "#212121",
                        }}
                      >
                        {item.description}
                      </Typography>
                      <Button
                        component={Link}
                        to={"/blog"}
                        style={{
                          fontSize: "0.5rem",
                          fontWeight: "700",
                          lineHeight: "0.6875rem",
                          letterSpacing: "0.0532384375rem",
                        }}
                      >
                        Read More
                      </Button>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            ))}
          </Box>
        </Container>
      ) : (
        <Container>
          <Box sx={{ marginTop: "3.75rem" }}>
            <BlogTypography variant="h2">Blogs</BlogTypography>
          </Box>
          <Box
            sx={{ marginTop: "4.4375rem", display: "flex", flexWrap: "nowrap" }}
          >
            <Box sx={{ flex: "1", paddingRight: "1rem" }}>
              <img
                src={Blog1}
                alt=""
                style={{ width: "100%", maxHeight: "100%" }}
              />
            </Box>
            <Box sx={{ flex: "1" }}>
              <Typography
                variant="h5"
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: 700,
                  color: "#212121",
                }}
              >
                Simplifying Complexity: Designing an Uncluttered EdTech Admin Interface
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  marginTop: "2rem",
                  fontSize: "1.25rem",
                  fontWeight: 400,
                  letterSpacing: "0.01rem",
                  color: "#212121",
                }}
              >
                In the dynamic landscape of educational technology, efficiency is key. In this article, we delve into the art and science of designing an uncluttered administrative interface for your edtech platform. Join us as we explore strategies to declutter, streamline, and optimize the admin experience, ensuring that educators and administrators can focus on what truly matters: shaping the future of education. Discover how simplicity and efficiency converge to revolutionize the way you navigate the complexities of edtech administration.
              </Typography>
              <Button component={Link} to={"/blog"} sx={{ marginTop: "2rem" }}>READ FULL ARTICLE</Button>
            </Box>
          </Box>
          <Box sx={{ marginTop: "7.5rem", marginBottom: "7.5rem" }}>
            {colData.map((item, index) => (
              <Box
                sx={{
                  marginBottom: "3.75rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
                key={index}
              >
                {item.rowData.map((item, index) => (
                  <Card
                    sx={{
                      height: "27.875rem",
                      width: "21rem",
                      boxShadow: "0px 8px 24px rgba(88, 101, 242, 0.15)",
                      position: "relative",
                    }}
                    key={index}
                  >
                    <CardMedia
                      component="img"
                      alt=""
                      image={item.image}
                      sx={{
                        height: "16.375rem",
                        width: "21rem",
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{
                        transform: "translateY(-100%)",
                        flexWrap: "nowrap",
                        position: "absolute",
                        color: "#FFFFFF",
                        width: "18.5rem",
                        fontSize: "1.5rem",
                        fontWeight: 400,
                        textAlign: "center",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <CardContent>
                      <Typography
                        variant="h6"
                        sx={{
                          height: "6rem",
                          width: "18.625rem",
                          fontSize: "1.25rem",
                          fontWeight: 400,
                          letterSpacing: "0.01rem",
                          color: "#212121",
                        }}
                      >
                        {item.description}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button component={Link} to={"/blog"} >Read More</Button>
                    </CardActions>
                  </Card>
                ))}
              </Box>
            ))}
          </Box>
        </Container>
      )}
    </ThemeProvider>
  );
};

export default Blogs;
